










import Vue from 'vue'
import Component from 'vue-class-component'
import moment from 'moment'

@Component({})
export default class CollectionOutstandingBalance extends Vue {
  intervalLabels: string[] = ['Prebill', '0-30', '30-60', '60-90', '90-120', '120-150', '150-180', '180+']

  format (money: any) {
    const value = (money || '0').toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    return `$${value}`
  }

  get tooltipsDates () {
    return this.intervalLabels.map((item: string, index: number) => moment()
      .add(1, 'months')
      .subtract(index, 'months')
      .startOf('month')
      .format('M/YYYY')
    )
  }

  get intervals () {
    return this.$store.state.transactions.transactionIntervals
  }
}
